import _createForOfIteratorHelper from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/createForOfIteratorHelper.js";
import _asyncToGenerator from "/opt/atlassian/pipelines/agent/build/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "regenerator-runtime/runtime.js";
import { defineComponent, ref } from "vue"; // modules

import { useI18n } from "vue-i18n";
import POSConfigModule from "@/store/modules/pos-config";
import { getConnectedTerminals, TerminalConnectivity } from "@/utils/vue-helpers/common";
export default defineComponent({
  name: "TerminalsStatus",
  components: {},
  setup: function setup() {
    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
      var terminalsConnection, groupTerminals, _iterator, _step, _terminalsConnection$, _t, _useI18n, t;

      return regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              terminalsConnection = ref([]);
              groupTerminals = POSConfigModule.groupTerminals;
              _iterator = _createForOfIteratorHelper(groupTerminals);

              try {
                for (_iterator.s(); !(_step = _iterator.n()).done;) {
                  _t = _step.value;
                  (_terminalsConnection$ = terminalsConnection.value) === null || _terminalsConnection$ === void 0 ? void 0 : _terminalsConnection$.push({
                    terminalId: _t,
                    connection: TerminalConnectivity.Loading
                  });
                }
              } catch (err) {
                _iterator.e(err);
              } finally {
                _iterator.f();
              }

              _useI18n = useI18n({}), t = _useI18n.t;
              return _context.abrupt("return", {
                terminalsConnection: terminalsConnection,
                TerminalConnectivity: TerminalConnectivity,
                t: t
              });

            case 6:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }))();
  },
  methods: {
    checkConnectedTerminals: function checkConnectedTerminals() {
      var _this = this;

      return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var connectedTerminals, _iterator2, _step2, t;

        return regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return getConnectedTerminals();

              case 2:
                connectedTerminals = _context2.sent;

                if (_this.terminalsConnection) {
                  _iterator2 = _createForOfIteratorHelper(_this.terminalsConnection);

                  try {
                    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
                      t = _step2.value;

                      if (connectedTerminals.includes(t.terminalId)) {
                        // Terminal is connected
                        t.connection = TerminalConnectivity.Connected;
                      } else {
                        // Terminal is disconnected
                        t.connection = TerminalConnectivity.Disconnected;
                      }
                    }
                  } catch (err) {
                    _iterator2.e(err);
                  } finally {
                    _iterator2.f();
                  }
                }

              case 4:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2);
      }))();
    }
  },
  mounted: function mounted() {
    var _this2 = this;

    return _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
      return regeneratorRuntime.wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              _context3.next = 2;
              return _this2.checkConnectedTerminals();

            case 2:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }))();
  }
});